import {getDateString} from "@/helper/dateService";

function getInitialState() {
  return {
    artAenderung: [],
    altVertrag: {},
    vertragsnummer: '',
    gueltigAb: getDateString(new Date(new Date().setDate(new Date().getDate() + 1))),
    gueltigAbVergangenheit: false,
    plzalter: "",
    vn: {
      anrede: "",
      titel: "",
      firstname: "",
      lastname: "",
      strasse: "",
      hausnummer: "",
      adresszusatz: "",
      plz: "",
      ort: "",
      geburt: "",
      beruf: null,
      email: "",
      mobil: "",
      telefon: "",
      staat: null,
      hasvorversicherung: null,
      anzahlvorversicherungen: 1,
      vorversicherung: [
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        },
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        },
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        }
      ],
      hasRechtsstreitigkeiten: null,
      anzahlRechtsstreitigkeiten: null,
      leistungshoeheRechtsstreitigkeiten: null,
      hasAnwaltsbesuche: null,
      anzahlAnwaltsbesuche: null,
      leistungshoeheAnwaltsbesuche: null,
      streitAktuell: null,
      anwaltGeplant: null
    },
    mvp: {
      unused: ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
      anrede: "",
      titel: "",
      firstname: "",
      lastname: "",
      geburt: "",
      beruf: null,
      hasvorversicherung: null,
      anzahlvorversicherungen: 1,
      vorversicherung: [
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        },
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        },
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        }
      ],
      hasRechtsstreitigkeiten: null,
      anzahlRechtsstreitigkeiten: null,
      leistungshoeheRechtsstreitigkeiten: null,
      hasAnwaltsbesuche: null,
      anzahlAnwaltsbesuche: null,
      leistungshoeheAnwaltsbesuche: null,
      streitAktuell: null,
      anwaltGeplant: null
    },

    submitTime: null,

    // created angebot
    angebotsnummer: '',
    guid: '',
    pdfpfad: '',

    //step1
    civilServant: null,
    categories: [],
    family: null,
    contractlength: null,
    sus: false,

    trafficType: null,
    car1license: '',
    car2license: '',
    car3license: '',
    car4license: '',
    car5license: '',
    showkfz: 0,

    yoligekfz: false,
    yoligazubi: false,
    yoligrentner: false,
    nurnachhaltig: false,

    // step2
    ssrselected: false,
    ssrdisabled: true,
    ssrsb: 'SB150',

    cyberselected: false,
    cyberdisabled: false,
    cybersb: 'SB150',

    zwselected: false,
    zwdisabled: true,
    zweitwohnung: {
      id: "Zweitwohnung",
      beschreibung: "Zweitwohnung",
      strasse: "",
      hausnummer: "",
      ort: "",
      plz: "",
      bruttojahresmiete: "",
      land: "",
      sb: ""
    },

    vermselected: false,
    vermdisabled: false,
    vermwohnungen: [{
      id: "Wohneinheit 1",
      beschreibung: "Wohneinheit 1",
      strasse: "",
      hausnummer: "",
      ort: "",
      plz: "",
      land: "Deutschland",
      sb: "SB300",
      bruttojahresmiete: null,
      hasError: true
    }],
    vermvalid: false,

    //STD EXP PRE
    productLine: '',
    //"SB100", "SB300", "SB0"
    sb: '',
    tmpMatrixState: {
      family: 'MPH',
      contractlength: null,
      categories: [],
      ssrselected: false,
      sb: "",
      productLine: "",
      sus: false
    },

    //step3: beitragszahlung
    rechnungszahler: "",
    zahlweise: "1",
    iban: "",
    bic: "",
    inhabertyp: "",
    kontoinhaber: {
      unused: ["beruf", "email", "telefon", "mobil", "staat", "geburt"],
      anrede: "",
      titel: "",
      firstname: "",
      lastname: "",
      adresszusatz: "",
      strasse: "",
      hausnummer: "",
      plz: "",
      ort: ""
    },

    //step4
    hauptfaelligkeit: null,
    aula: null,
    invitatio: null,
    werbezwecke: null,

    //Änderungsseite - Anmerkungen
    anmerkungen: "",

    //Änderungsseite - FileUpload
    files: [],
    fileIds: []
  };
}

const state = getInitialState();

const getters = {};

const mutations = {
  markAsChanged(state, { section }) {
    if (state.artAenderung.indexOf(section) < 0) state.artAenderung.push(section);
  },
  loadAenderungsAngebot(state, data) {
    Object.assign(state, data);
  },
  setVertragForAenderung(state, { vertragsnummer, firstname, lastname, altvertrag }) {
    state.altVertrag = altvertrag;
    state.vertragsnummer = vertragsnummer;
    if (!state.vn.firstname) state.vn.firstname = firstname;
    if (!state.vn.lastname) state.vn.lastname = lastname;
  },
  resetAenderungsData(state) {
    Object.assign(state, getInitialState());
  },
  restoreAenderungState(state, tmpState) {
    Object.assign(state, tmpState);
  }
};

const actions = {
  loadAenderungsAngebot(context, data) {
    context.commit("loadAenderungsAngebot", data);
  },
  resetAenderungsData(context) {
    context.commit("resetSteps", { page: 'aenderung' });
    context.commit("resetAenderungsData");
    //window.location.reload();
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
